module.exports = __webpack_public_path__ + "static/media/greenCheck.68f20110.svg";